import { render } from "./ToggleButton.vue?vue&type=template&id=6d5cbab4&scoped=true"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=6d5cbab4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\버들이\\Documents\\Project\\John-I-gotta-go\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5cbab4"]])

export default __exports__